import { SkillFrom } from '../interface'

import { SkillIFrame } from './SkillIFrame'
import { useSkillHandler } from './useSkillHandler'

export interface SkillProps {
  customer?: { session: string }
  from: SkillFrom
  id: string
  params?: Record<string, unknown>
  preview?: boolean
  src: string
}

export function Skill({ src, id, customer, params, preview, from }: SkillProps) {
  const { $skillRef, height } = useSkillHandler({ id })
  const handleSkillLoad = () => {
    $skillRef?.current?.contentWindow?.postMessage(
      {
        type: 'init',
        _id: id,
        customer,
        params,
        skillParams: {
          from,
          preview,
        },
      },
      '*'
    )
  }

  return (
    <SkillIFrame
      $skillRef={$skillRef}
      height={height}
      src={src}
      handleSkillLoad={handleSkillLoad}
    />
  )
}
